import { Box, Stack, TextField, Typography } from "@mui/material";
import { useNewGetUsers, UserDto } from "../http";
import { Autocomplete } from "./Autocomplete";
import React from "react";

interface IProps {
  placeholder?: string;
  value: UserDto | null;
  options?: UserDto[];
  error?: boolean;
  helperText?: React.ReactNode;
  disableClearable?: boolean;
  disabled?: boolean;
  autofocus?: boolean;
  optionsFilter?: (user: UserDto) => boolean;
  onBlur?: () => void;
  onChange?: (value: UserDto | null) => void;
}

const UserAutocomplete = React.forwardRef((props: IProps, ref: React.Ref<unknown>) => {
  const { data, isLoading } = useNewGetUsers(!props.options && !props.disabled);

  return (
    <Autocomplete
      ref={ref}
      isLoading={isLoading}
      disabled={isLoading || (data?.users == null && !props.options) || props.disabled}
      options={
        props.options ??
        (data?.users ? (props.optionsFilter ? data.users.filter(props.optionsFilter) : data.users) : [])
      }
      getOptionLabel={(option) => option.displayName}
      onBlur={props.onBlur}
      onChange={(_, value) => props.onChange?.(value)}
      renderOption={(props, option) => (
        <Box sx={{ pl: "10px !important" }} component="li" {...props} key={option.userId}>
          <Stack>
            <Typography>{option.displayName}</Typography>
            {option.email && <Typography variant="caption">{option.email}</Typography>}
          </Stack>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={props.placeholder}
          slotProps={{ htmlInput: { ...params.inputProps } }}
          error={props.error}
          helperText={props.helperText}
          autoFocus={props.autofocus}
        />
      )}
      blurOnSelect={false}
      disableClearable={props.disableClearable}
      isOptionEqualToValue={(option, value) => option.userId === value.userId}
      value={props.value}
    />
  );
});

export { UserAutocomplete };
